import Head from 'next/head';
import { useContext, useEffect, useState } from 'react';
import AppContext from '../../store/AppContext';
import environment from '../../utils/environment';
import { constant } from '../../utils/constant';
import { getMetaImg } from '../../utils/utils';
import { useRouter } from 'next/router';
import moment from 'moment';
  
const HeadComponent = ({ gSnippet, seo, linkCanonical }:any) => {
    const { generalSetting } = useContext(AppContext);
    const [imageSize, setImageSize]:any = useState(null);
    
    // //@ts-ignore
    // useEffect(() => {

    //     setUrl(window?.location?.href);

    // }, [])

    async function loadImageSize(){
        if(seo?.file?.file_url){
            try{
                let imageSize:any = await getMetaImg(seo.file.file_url);
                await setImageSize({
                    width: imageSize.naturalWidth,
                    height: imageSize.naturalHeight
                })
            }catch(e){

            }
            
        }
            
    }
    const router = useRouter();
    useEffect(() => {
        loadImageSize()
    }, [seo?.file?.file_url])

    return <>
    {
        
        <Head>
            <title>{seo?.title && seo?.title != "" ? seo?.title : constant.title_page}</title>
            <meta name="robots" content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
            <link rel="canonical" href={seo?.url} />
            {
                linkCanonical?.url_prev && <link rel="prev" href={linkCanonical?.url_prev} />
            }
            {
                linkCanonical?.url_next && <link rel="next" href={linkCanonical?.url_next} />
            }
            <meta key={"og:url"} property={'og:url'} content={seo?.url} />
            <meta key={"og:locale"} property={'og:locale'} content={"vi_VN"} />
            <meta key={"og:site_name"} property={'og:site_name'} content={constant.name_page} />
            <meta key={"og:updated_time"} property={'og:updated_time'} content={moment(seo?.updated_date ?? new Date()).format()} />
            <meta name="twitter:title" content={seo?.title && seo?.title != "" ? seo?.title : constant.title_page} />
            <meta name="twitter:card" content="summary_large_image"></meta>
            <meta key={"og:title"} property={'og:title'} content={seo?.title && seo?.title != "" ? seo?.title : constant.title_page} />
            {
                seo?.description && <meta key={"description"} name="description" content={seo?.description} /> 
            }
            {
                seo?.description && <meta key={"og:description"} property={'og:description'} content={seo?.description} /> 
            }
            {
                seo?.description && <meta name="twitter:description" content={seo?.description} />
            }
            {
                seo?.keyword && seo?.keyword.length > 0 && <meta key={'keywords'} name={'keywords'} content={seo?.keyword?.map((x:any)=>x.keyword)?.join(", ").trimEnd()} />
            }
            {
                seo?.type && seo?.type == 1 && <meta property="og:type" content="product"></meta>
            }
            {
                seo?.type && seo?.type == 2 && <meta property="og:type" content="website"></meta>
            }
            {
                seo?.type && (seo?.type == 0 || seo?.type == 3) && <meta property="og:type" content="article"></meta>
            }
            {
                seo?.product && seo?.product.price && <meta property="product:price:amount" content={seo.product.price}></meta>
            }
            {
                seo?.product && seo?.product.price && <meta property="product:price:currency" content="VND"></meta>
            }
            {/* {
                seo?.product && seo?.product.availability && <meta property="product:availability" content="instock"></meta>
            } */}
            {
                seo?.file?.file_url && <meta key={"og:image"} property={'og:image'} content={seo?.file?.file_url} />
            }
            {
                seo?.file?.file_url && imageSize && imageSize.width && <meta property="og:image:width" content={imageSize.width}/> 
            }
            {
                seo?.file?.file_url && imageSize && imageSize.height && <meta property="og:image:height" content={imageSize.height}/>
            }
            {
                seo?.file?.file_url && <meta key={"og:image:secure_url"} property={'og:image:secure_url'} content={seo?.file?.file_url} />
            }
            {
                seo?.file?.file_url && seo?.file?.file_type && <meta key={"og:image:type"} property={'og:image:type'} content={seo?.file?.file_type} />
            }
            {
                seo?.file?.file_url && seo?.file?.alt && <meta key={"og:image:alt"} property={'og:image:alt'} content={seo?.file?.alt} />
            }
            {/* <meta key={"article:published_time"} property={'article:published_time'} content={moment(seo?.created_date ?? new Date()).format()} /> */}
            <meta name="msapplication-TileImage" content={constant.url_logo}></meta>
            <link rel="icon" href={generalSetting?.system_config?.system_image_favicon ? environment.baseUsmImageUrl + generalSetting?.system_config?.system_image_favicon : "/asset/icon/favicon.ico"} />
            {
                gSnippet && <script type="application/ld+json" className="rank-math-schema" dangerouslySetInnerHTML={{ __html: JSON.stringify(gSnippet) }} />
            }

            <link rel="preload" href="/font/Quicksand-Regular.ttf" as="font" crossOrigin="anonymous"/>
        </Head> 
    }
    
    </>
}

export default HeadComponent;
